// react-select styles itself in JS (emotion), so none of theme.css reaches it —
// it kept rendering a white control on a black page. These are the panel's
// tokens restated as the object react-select actually reads.
//
// The values are literals rather than var(--ps-*) because react-select composes
// them in JS, where a CSS variable is only a string it cannot resolve. Keep
// them in step with src/styles/theme.css by hand.
const BG = "#1a1a1a"; // --ps-surface-2
const BG_MENU = "#141414"; // --ps-surface
const BORDER = "rgba(250, 250, 248, 0.08)"; // --ps-border
const TEXT = "#f2f2f2"; // --ps-text / grey50
const MUTED = "#acacac"; // --ps-text-muted / grey300
const GREEN = "#96bf48"; // --ps-green
const GREEN_INK = "#0d0d0d"; // --ps-green-ink

export const darkSelectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: BG,
    borderColor: state.isFocused ? GREEN : BORDER,
    boxShadow: state.isFocused ? `0 0 0 1px ${GREEN}` : "none",
    color: TEXT,
    ":hover": { borderColor: state.isFocused ? GREEN : BORDER },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: BG_MENU,
    border: `1px solid ${BORDER}`,
    zIndex: 20,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? GREEN
      : state.isFocused
        ? BG
        : "transparent",
    color: state.isSelected ? GREEN_INK : TEXT,
    ":active": { backgroundColor: state.isSelected ? GREEN : BG },
  }),
  singleValue: (base) => ({ ...base, color: TEXT }),
  input: (base) => ({ ...base, color: TEXT }),
  placeholder: (base) => ({ ...base, color: MUTED }),
  // Multi-select chips: a green tint rather than the default light grey, which
  // on this ground read as holes punched in the control.
  multiValue: (base) => ({ ...base, backgroundColor: "rgba(150, 191, 72, 0.18)" }),
  multiValueLabel: (base) => ({ ...base, color: TEXT }),
  multiValueRemove: (base) => ({
    ...base,
    color: MUTED,
    ":hover": { backgroundColor: GREEN, color: GREEN_INK },
  }),
  indicatorSeparator: (base) => ({ ...base, backgroundColor: BORDER }),
  dropdownIndicator: (base) => ({
    ...base,
    color: MUTED,
    ":hover": { color: TEXT },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: MUTED,
    ":hover": { color: TEXT },
  }),
  noOptionsMessage: (base) => ({ ...base, color: MUTED }),
  loadingMessage: (base) => ({ ...base, color: MUTED }),
  groupHeading: (base) => ({ ...base, color: MUTED }),
};

// react-select builds a few colours itself (the focus ring, the "no options"
// state). Handing it the palette here stops those slipping back to its
// defaults, which are built for a white page.
export const darkSelectTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: GREEN,
    primary75: "rgba(150, 191, 72, 0.75)",
    primary50: "rgba(150, 191, 72, 0.5)",
    primary25: BG,
    neutral0: BG_MENU,
    neutral5: BG,
    neutral10: BG,
    neutral20: BORDER,
    neutral30: BORDER,
    neutral40: MUTED,
    neutral50: MUTED,
    neutral60: TEXT,
    neutral80: TEXT,
    neutral90: TEXT,
  },
});
